import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Button } from '#app/shared/ui/inputs/button/Button.js'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '#app/shared/ui/navigation/Tabs.js'
import {
  TypeOfPayment,
  type TypeOfPaymentType,
} from '../../../../../types/enums'

type Props = {
  setTypeOfPayment: (value: TypeOfPaymentType) => void
}

export default function ReservationTabs({ setTypeOfPayment }: Props) {
  return (
    <div
      className={`
        w-full pt-[31px]

        lg:max-w-[650px]

        xl:max-w-full xl:pl-[100px]
      `}
    >
      <p
        className={`
          text-h5-bold text-neutral-900

          xl:text-h3
        `}
      >
        ¡Vamos a reservar este coche para ti!
      </p>

      <Spacer size="16px" />
      <p className="text-base-medium text-neutral-500">
        ¿Qué tipo de operación te gustaría usar, al contado o financiada?
      </p>
      <Spacer size="36px" />

      <Tabs defaultValue={'Financiado'} className="xl:w-full">
        <p className="mb-3 text-subtitle1-bold text-neutral-900">
          Forma de pago
        </p>
        <TabsList
          className={`
            flex !h-14 max-w-[675px] items-center gap-4 !rounded-[8px] !border
            !border-neutral-100 !bg-white px-1.5
          `}
        >
          <TabsTrigger
            className={`
              h-11 text-base-bold font-bold text-neutral-500

              data-[state=active]:rounded-base data-[state=active]:border
              data-[state=active]:border-neutral-100
              data-[state=active]:bg-neutral-25
              data-[state=active]:text-neutral-900

              hover:border-0 hover:text-neutral-500
            `}
            value="Financiado"
          >
            Financiado
          </TabsTrigger>
          <TabsTrigger
            className={`
              h-11 text-base-bold font-bold text-neutral-500

              data-[state=active]:rounded-base data-[state=active]:border
              data-[state=active]:border-neutral-100
              data-[state=active]:bg-neutral-25
              data-[state=active]:text-neutral-900

              hover:border-0 hover:text-neutral-500
            `}
            value="Al contado"
          >
            Al contado
          </TabsTrigger>
        </TabsList>

        <TabsContent value="Financiado">
          <Button
            variant="primary"
            className="h-12 max-w-[110px] text-base-bold text-white"
            onClick={() => setTypeOfPayment(TypeOfPayment.FINANCIADO)}
          >
            Siguiente
          </Button>
        </TabsContent>

        <TabsContent value="Al contado">
          <Button
            variant="primary"
            className="h-12 max-w-[110px] text-base-bold text-white"
            onClick={() => setTypeOfPayment(TypeOfPayment.AL_CONTADO)}
          >
            Siguiente
          </Button>
        </TabsContent>
      </Tabs>
    </div>
  )
}
